import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-[#0d0d0d] py-12 px-5" data-id="element-112">
      <div className="max-w-[800px] mx-auto" data-id="element-113">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-center mb-8 leading-[1.2]" data-id="element-114">
          Tu inversión está{' '}
          <span className="text-brand-orange" data-id="element-115">100% protegida</span>
        </h2>

        <div className="bg-gradient-to-br from-[#0f1a0f] to-[#0a150a] border-2 border-brand-green rounded-2xl p-6 md:p-10 max-w-[700px] mx-auto text-center" data-id="element-116">
          <div className="text-[60px] mb-4 leading-none" data-id="element-117">🛡️</div>
          <h3 className="font-oswald text-2xl md:text-[32px] text-brand-green mb-4 font-bold" data-id="element-118">
            Garantía Total de 30 Días
          </h3>
          <p className="text-sm md:text-base text-[#bbb] leading-[1.7]" data-id="element-119">
            Si por cualquier motivo el{' '}
            <strong className="text-white font-semibold" data-id="element-120">
              Protocolo Blackout
            </strong>{' '}
            no cumple con tus expectativas en los próximos 30 días, te
            devolvemos cada peso de tu inversión. Sin preguntas, sin
            formularios, sin burocracia. Tu satisfacción o tu dinero de vuelta.
            Así de simple.{' '}
            <strong className="text-brand-green font-semibold" data-id="element-121">
              El riesgo es 100% nuestro.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}